import { Type } from '../app/swapi.service';
export class SelectedItem{
    item : any;
    type : Type;
}


// WEBPACK FOOTER //
// ./src/models/selectedItem.ts